import { HTMLAttributes, ReactNode } from 'react'
import clsx from 'clsx'
import Errors from '@tandem/ui/Errors'
import $form from '@tandem/ui/form.css'
import $type from '@tandem/ui/type.css'
import $layout from '@tandem/ui/layout.css'

export interface FormFieldProps {
  field: any
  label?: ReactNode
  required?: boolean
  inline?: boolean
  icon?: ReactNode
  footnote?: ReactNode
  errorFormat?: Record<string, string>
  afterInput?: ReactNode
  suggestions?: Array<{
    key: string | number
    label: ReactNode
    onSelect: () => void
  }>
  children: ReactNode
}

export default function FormField({
  field,
  label,
  required,
  inline,
  icon,
  footnote,
  errorFormat,
  afterInput,
  suggestions,
  children,
  ...rest
}: FormFieldProps & HTMLAttributes<HTMLDivElement>) {
  if (inline) {
    return (
      <div class={$form.field}>
        <div class={$form.inline}>
          {children}
        </div>
        {field.state.meta.isTouched && <Errors errors={field.state.meta.errors} format={errorFormat} />}
      </div>
    )
  }

  return (
    <div {...rest} class={clsx($form.field, rest.class)}>
      <div class={clsx($form.float, { [$layout.withIcon]: icon })}>
        {icon && <span class={$layout.icon}>{icon}</span>}
        {children}
        {label && (
          <label>
            {label}
            {/*{required && <em>*</em>}*/}
          </label>
          )}
        </div>
      {footnote && <small class={$type.footnote}>{footnote}</small>}
      {suggestions && suggestions.length > 0 && (
        <div class={$form.suggestions}>
          {suggestions.map((s) => (
            <button type='button' key={s.key} class={$form.suggestionPill} onClick={s.onSelect}>
              {s.label}
            </button>
          ))}
        </div>
      )}
      {afterInput}
      {field.state.meta.isTouched && <Errors errors={field.state.meta.errors} format={errorFormat} />}
    </div>
  )
}
